// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import circleCards from './js/widgets/circleCards.js';

import mainSeoBlock from './js/widgets/tier-3-section/mainSeoBlock.js';
import autoEvent4 from './js/widgets/tier-3-section/autoEvent4.js';
import * as socialNetworkWidget from './js/widgets/tier-3-section/socialNetworkWidget';

import exploreSeo from './js/widgets/explore-section/exploreSeo.js';
import exploreBlocks from './js/widgets/explore-section/exploreBlocks.js';

import secondarySlideshow from './js/widgets/secondarySlideshow.js';
import scrollerSponsorsDouble from './js/widgets/scrollerSponsorsDouble.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    circleCards();

    mainSeoBlock();
    autoEvent4();

    $(globalThis).on('load', function () {
      socialNetworkWidget.facebookfeed(true);
    });

    exploreSeo();
    exploreBlocks();
    secondarySlideshow('secondarySlideshow', secondarySlideshowOpts);
    scrollerSponsorsDouble('scroller-sponsors-second', scrollerSponsorsSecondOpts, 7);
    scrollerSponsorsDouble('scroller-sponsors-first', scrollerSponsorsFirstOpts, 3);
  }
});
